import { Helmet } from "react-helmet-async";
import { ArrowLeft, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import Gallery from "@/components/Gallery";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyPhone from "@/components/StickyPhone";
import { useGalleryImages } from "@/hooks/useGalleryImages";

const ResidentialGallery = () => {
  const { images, loading } = useGalleryImages("residential");

  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Residential Gallery | Hill Brothers</title>
        <meta name="description" content="Browse our residential painting projects across New Hampshire. Interior, exterior, cabinets, decks, and more. Call 603 424 4608." />
        <meta property="og:title" content="Residential Gallery | Hill Brothers" />
        <meta property="og:description" content="See our residential painting work across New Hampshire. Interior, exterior, cabinets, decks, and trim for homeowners." />
        <meta property="og:url" content="https://hillbrothersnh.com/residential" />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content="Residential Gallery | Hill Brothers" />
        <meta name="twitter:description" content="See our residential painting work across New Hampshire." />
        <link rel="canonical" href="https://hillbrothersnh.com/residential" />
        <script type="application/ld+json">{JSON.stringify({
          "@context":"https://schema.org","@type":"BreadcrumbList",
          itemListElement:[
            {"@type":"ListItem",position:1,name:"Home",item:"https://hillbrothersnh.com/"},
            {"@type":"ListItem",position:2,name:"Residential Gallery",item:"https://hillbrothersnh.com/residential"}
          ]
        })}</script>
      </Helmet>

      <Header />
      
      <main className="pt-20">
        <section className="bg-primary py-16">
          <div className="section-container">
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 text-primary-foreground/80 hover:text-primary-foreground mb-4 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Home
            </Link>
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-primary-foreground mb-4">
              Residential Projects
            </h1>
            <p className="text-xl text-primary-foreground/80 max-w-2xl">
              Transforming New Hampshire homes with expert interior and exterior painting services.
            </p>
          </div>
        </section>

        {loading ? (
          <div className="flex justify-center py-20">
            <Loader2 className="w-8 h-8 animate-spin text-primary" />
          </div>
        ) : (
          <Gallery
            id="residential-gallery"
            title="Our Residential Work"
            subtitle="Beautiful results for homeowners across New Hampshire."
            images={images}
          />
        )}
      </main>
      
      <Footer />
      <StickyPhone />
    </div>
  );
};

export default ResidentialGallery;
